import { render, staticRenderFns } from "./CoatingBreakdown.vue?vue&type=template&id=7b3cd2a5&"
import script from "./CoatingBreakdown.vue?vue&type=script&lang=js&"
export * from "./CoatingBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b3cd2a5')) {
      api.createRecord('7b3cd2a5', component.options)
    } else {
      api.reload('7b3cd2a5', component.options)
    }
    module.hot.accept("./CoatingBreakdown.vue?vue&type=template&id=7b3cd2a5&", function () {
      api.rerender('7b3cd2a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/CoatingBreakdown.vue"
export default component.exports